import { render, staticRenderFns } from "./authoritySettings.vue?vue&type=template&id=edcfe4c4&scoped=true&"
import script from "./authoritySettings.vue?vue&type=script&lang=js&"
export * from "./authoritySettings.vue?vue&type=script&lang=js&"
import style0 from "./authoritySettings.vue?vue&type=style&index=0&id=edcfe4c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcfe4c4",
  null
  
)

export default component.exports